import React, { Component } from 'react'
import './Full_W_Art.css';
import FullWArtImg from './Full_W_Article_Com/Full_W_Article_Img.jpg';
import FullWArtTitle from './Full_W_Article_Com/Full_W_Article_Title.csv';
import FullWArtBody from './Full_W_Article_Com/Full_W_Article_Body.csv';

class fullWArticle extends Component {
  render() {
    return (
      <div className="fullWArticle">
       <div class="container_fullWArt">
        <div class="jumbotron_fullWArt">
          <div className="fullWArtTitle">
            The Constitution
            </div>
            <div className="fullWArtImg">
              <img src={FullWArtImg} />
            </div>
            <div className="fullWArtBody">
            Section 1 All legislative Powers herein granted shall be vested in a Congress of the United States, which shall consist of a Senate and House of Representatives.
           Section 2 1: The House of Representatives shall be composed of Members chosen every second Year by the People of the several States, and the Electors in each State shall have the Qualifications requisite for Electors of the most numerous Branch of the State Legislature.
           2: No Person shall be a Representative who shall not have attained to the Age of twenty five Years, and been seven Years a Citizen of the United States, and who shall not, when elected, be an Inhabitant of that State in which he shall be chosen.
            </div>
          </div>
        </div>
      </div>
      )
    }
  }
export default fullWArticle;
